import { Doc, generateToDocFn } from '@dadohr/shared/domainTypes/document';
import { AirtableIntegrationConfigV2 } from '@dadohr/shared/domainTypes/integrations/airtable';
import { FS } from '@dadohr/shared/versions';
import {
  store,
  useMappedLoadingValue
} from '../../../../../../services/firebase';
import {
  createDocumentListenerGetter,
  useDocumentListener
} from '../../../../../../services/firecache/documentListener';
import { now } from '../../../../../../services/time';

export const toAirtableConfigDoc = generateToDocFn<AirtableIntegrationConfigV2>();

const COLLECTION = FS.airtableIntegrationConfigV2;
const collection = () => store().collection(COLLECTION);
export const airtableConfigStore = createDocumentListenerGetter(
  (orgId) => collection().doc(orgId),
  toAirtableConfigDoc
);

export const useAirtableConfig = (orgId: string, userId: string) => {
  return useMappedLoadingValue(
    useDocumentListener(airtableConfigStore(orgId)),
    (d) => {
      if (!d) {
        const n = now();
        const newConfig: Doc<AirtableIntegrationConfigV2> = {
          id: orgId,
          collection: COLLECTION,
          data: {
            orgId,
            active: false,
            createdAt: n,
            createdBy: userId,
            editedAt: n,
            editedBy: userId,
            accessToken: '',
            refreshToken: '',
            expiresAt: now(),
            refreshExpiresAt: now()
          }
        };
        return newConfig;
      }
      return d;
    }
  );
};

export const removeAirtableConfig = (orgId: string) => {
  return collection().doc(orgId).delete();
};
